import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { catchError, map, switchMap, take } from 'rxjs/operators';
import { selectBffBaseUrl } from '../../store/selectors/api-config.selectors';
import { MatrixPersonResponseDTO } from '@core/models/matrix-messenger/matrix-person.dto.model';
import { PersonWithMatrixId } from '@core/data/persons/messaging-person.model';

@Injectable({
  providedIn: 'root',
})
export class MessengerApiService {
  private baseAppAccountPath$: Observable<string>;

  constructor(
    private http: HttpClient,
    private store: Store,
  ) {
    this.baseAppAccountPath$ = this.store.pipe(
      selectBffBaseUrl,
      map((url) => `${url}/app/account`) /** @todo move to app-config */,
      take(1),
    );
  }

  getMatrixId$() {
    return this.baseAppAccountPath$.pipe(
      switchMap((baseAppAccountPath) =>
        this.http
          .get<any>(`${baseAppAccountPath}/myaccount/messaging/matrix/id`)
          .pipe(map(({ matrixId }) => matrixId)),
      ),
    );
  }

  /**
   * The request is used for detecting wether the person has a messaging possiblity
   * @param messagingPerson with {@link PersonWithMatrixId}
   * @returns observable of boolean for the person's matrix flag
   */
  public personHasMatrixFlag$(
    messagingPerson: PersonWithMatrixId,
  ): Observable<boolean> {
    return this.baseAppAccountPath$.pipe(
      switchMap((baseAppAccountPath) =>
        this.http.post<any>(
          `${baseAppAccountPath}/myaccount/messaging/matrix/personflags`,
          { Person: [{ matrixId: messagingPerson.matrixId }] },
        ),
      ),
      map((response: MatrixPersonResponseDTO) => response.Person[0].matrixFlag),
      catchError((error) => {
        throw new Error(
          `Error fetching matrix flag for person: ${messagingPerson.person.id}. Error: ${error}`,
        );
      }),
    );
  }
}
